<template>
  <div class="row">
    <div class="col-md-4">
      <img
        id="logo"
        :src="logo"
        class="img-responsive img-thumbnail custom-image"
        :alt="logo"
      />
    </div>
    <div class="col-md-8">
      <file-upload
        ref="fileUploader"
        title="Organization Logo"
        subtitle="(in png or jpg format)"
        instructions="Drag your organization logo (in png or jpg format) here to begin or click to browse"
        :endpoint="endpoint"
        :path="path"
        :folder="folder"
        :id="id"
        :accept="accept"
        @finished="finishedUploading"
        :key="uploadKey"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import FileUpload from '@/Components/ZElements/Upload'
export default {
  name: 'organization-logo',
  components: {
    FileUpload,
  },
  data() {
    return {
      readyToUpload: false,
      endpoint: 'api/v2/settings/uploadLogo',
      path: '/images/',
      uploadKey: 0,
      accept: 'image/png,image/jpeg',
    }
  },
  computed: {
    ...mapGetters('organizations', ['organization']),
    id() {
      let _data = null
      if (this.organization) {
        _data = this.organization.id
      }
      return _data
    },
    logo() {
      let _data = null
      if (this.organization) {
        var timestamp = new Date().getTime()
        _data = `${this.organization.logourl}?t=${timestamp}`
      }
      return _data
    },
    folder: {
      get() {
        return ''
      },
    },
  },
  methods: {
    ...mapActions('organizations', ['setOrganizationData']),
    refreshImage() {
      document.getElementById('logo').src = `${
        this.organization.logourl
      }?t=${new Date().getTime()}`
    },
    async finishedUploading(files) {
      if (files !== undefined && files !== null) {
        if (files.length > 0) {
          console.log('Setting Org Logo (after upload)', files)
          this.setOrganizationData({
            name: 'logourl',
            value: files,
          })
          this.uploadKey++
          this.refreshImage()
        }
      }
      this.$refs.fileUploader.reset()
      this.readyToUpload = false
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-image {
  width: 330px;
}
</style>
